module.exports = __webpack_public_path__ + "img/castalis_slim_vegetarian.20c2813e.jpg";